// extracted by mini-css-extract-plugin
module.exports = {"page":"BlogPost_page__YF1IV","article":"BlogPost_article__T3wDc","title":"BlogPost_title__iVYCX","date":"BlogPost_date__9kjS6","content":"BlogPost_content__VxbaP"};